module.exports = __webpack_public_path__ + "img/line3.673e14ac.png";